export default __webpack_public_path__ + "static/media/koscher.f62dadb1.svg";